export default __webpack_public_path__ + "static/media/Parched Blade of Slaughter Wine.8c011c91.jpg";